/* VaultsRenderer.js */

"use strict";

/* global Slick */
const _ = require("lodash");
const formatters = require("./cellFormaters");

const NO_DATA_PLACEHOLDER_MSG = "No Vaults to display";

const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;

const VaultEditComponent = require("./veil/vaultedit/VaultEditComponent");
const DeleteErrorVeilComponent = require("./veil/delete/DeleteErrorVeilComponent");

class VaultsRenderer {
    constructor(model, uiUtils) {
        this._model = model;
        this._uiUtils = uiUtils;
        this._rootElem = document.createElement("vaults-gl");
        this._rootElem.component = model;
        this._logger = this._model._logger;
        this._headerElem = document.createElement("h1");
        this._headerElem.innerText = "Vaults";
        this._headerElem.setAttribute("title", "");
        this._modalUserFeedback = this._model._modalUserFeedback;

        this._slickTableContainer = document.createElement("cred-fields-table");
        this._slickWrapper = document.createElement("cred-fields-table-wrapper");
        this._slickWrapper.appendChild(this._slickTableContainer);

        this._slickTable = undefined;

        this._columns = [
            {
                id: "name",
                width: 45,
                name: "Name",
                field: "name",
                toolTip: "Name",
                cssClass: "credname",
                sortable: true,
            },
            {
                id: "vendor",
                width: 30,
                name: "Vendor",
                field: "vendor",
                toolTip: "Vendor name",
                cssClass: "vendor-name",
                // formatter: formatters.typeFormatter,
                sortable: true,
            },
            // {
            //     id: "enabled",
            //     width: 20,
            //     name: "Enabled",
            //     field: "enabled",
            //     toolTip: "Vault is enabled/disbaled",
            //     formatter: formatters.checkboxFormatter,
            //     // editor: typeDropdownEditor,
            //     sortable: true,
            // },
            {
                id: "delete",
                width: 25,
                name: "Action",
                behavior: "deleteRow",
                selectable: false,
                toolTip: "Delete the Vault",
                formatter: formatters.deleteButtonFormatter,
                // asyncPostRender: this._deleteCellAddTooltips.bind(this),
                cssClass: "cell-delete centered",
                headerCssClass: "centered",
            },
        ];

        this._tableOptions = {
            editable: false,
            enableCellNavigation: true,
            enableTextSelectionOnCells: true,
            enableAsyncPostRender: true,
            forceFitColumns: true,
            autoHeight: true,
            autoEdit: false,
            resizable: true,
            rowHeight: 45,
        };

        /**
         * @type {ButtonControlComponent}
         * @private
         */

        this._addNewRowButton = new ButtonControl({
            label: "Add Vault +",
            position: "left",
            darkTheme: true,
            class: "add-new-row",
        });

        this._controlButtonsContainer = document.createElement("div");
        this._controlButtonsContainer.classList.add("control-buttons");

        this._controlButtonsContainerLeft = document.createElement("div");
        this._controlButtonsContainerLeft.classList.add("control-buttons-left");

        this._controlButtonsContainer.appendChild(this._controlButtonsContainerLeft);

        this._addNewRowAction = this._addNewRowAction.bind(this);
        this._clickHandler = this._clickHandler.bind(this);
        this._fitTableSize = this._fitTableSize.bind(this);
        this._onSort = this._onSort.bind(this);
    }

    get rootElement() {
        return this.getRootElement();
    }
    get model() {
        return this.getModel();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._addNewRowButton.on(
            "UserClick",
            (this._addNewRowAction = this._addNewRowAction.bind(this))
        );
        // this._downloadCsvButton.on("UserClick", (this._downloadCsv = this._downloadCsv.bind(this)));
        document.addEventListener("click", this._clickHandler);
        window.addEventListener("resize", this._fitTableSize);
        this._model.on("DataUpdated", (this._onDataUpdated = this._onDataUpdated.bind(this)));
        this._slickTable.onSort.subscribe(this._onSort);
    }

    _unregisterListeners() {
        this._addNewRowButton.removeListener("UserClick", this._addNewRowAction);
        // this._downloadCsvButton.removeListener("UserClick", this._downloadCsv);
        document.removeEventListener("click", this._clickHandler);
        window.removeEventListener("resize", this._fitTableSize);
        this._model.removeListener("DataUpdated", this._onDataUpdated);
        this._slickTable.onSort.unsubscribe(this._onSort);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    getRootElement() {
        return this._rootElem;
    }
    getModel() {
        return this._model;
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        if (this._model) {
            return this._model
                .whenModelIsReady()
                .then(() => {
                    this._rootElem.innerHTML = "";
                    this._slickTableContainer.innerHTML = "";
                    this._rootElem.appendChild(this._headerElem);
                    this._rootElem.appendChild(this._slickWrapper);
                    this._rootElem.appendChild(this._controlButtonsContainer);
                    if (!this._model._isReadOnly) {
                        this._controlButtonsContainer.appendChild(
                            this._addNewRowButton.renderer.getRootElement()
                        );
                    }
                    if (this._model._isReadOnly) {
                        this._disableActions();
                    }

                    this._toggleNoDataPlaceholder(_.isEmpty(this._model._slickData));
                    this._slickDataVIew = new Slick.Data.DataView();
                    this._slickDataVIew.setItems(this._model._slickData);

                    if (this._model._isReadOnly) {
                        this._slickTableContainer.classList.add("read-only");
                    }

                    this._slickTable = new Slick.Grid(
                        this._slickTableContainer,
                        this._slickDataVIew,
                        this._columns,
                        this._tableOptions
                    );

                    this._slickTable.setSelectionModel(new Slick.RowSelectionModel());

                    this._slickTableContainer.appendChild(this._createNoDataPlaceholder());

                    this._registerListeners();
                    document.querySelector(".slick-header-column[title='Name']").click();
                })
                .catch((err) => {
                    this._model._logger.warn(err);
                });
        }
    }

    shutdown() {
        this._unregisterListeners();
        const controls = [this._addNewRowButton];

        return Promise.all(_.invokeMap(controls, "shutdown")).then(() => {
            this._rootElem.remove();
            this._headerElem = undefined;
            this._rootElem = undefined;
            this._slickTableContainer = null;
            this._slickTable = null;
        });
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _showControls() {}

    _showForm() {}

    _disableActions() {}

    _createNoDataPlaceholder() {
        const noDataPlaceholder = document.createElement("div");
        noDataPlaceholder.classList.add("no-data-placeholder");
        noDataPlaceholder.innerText = NO_DATA_PLACEHOLDER_MSG;
        return noDataPlaceholder;
    }

    _toggleNoDataPlaceholder(state) {
        this._slickTableContainer.classList.toggle("empty", state);
    }
    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/
    _addNewRowAction(/*e, args*/) {
        this._editItem();
    }

    _clickHandler(e) {
        //if we click delete column
        const target = e.target;
        if (target.dataset.action === "delete" && target.dataset.uuid) {
            this._deleteItem(target.dataset.uuid);
        }

        if (target.dataset.action === "edit") {
            this._editItem(target.dataset.uuid);
            // }
        }
        // this._saveAndCloseEditCellAction(e);
    }

    _deleteItem(uuid) {
        const item = this._slickDataVIew.getItemById(uuid);

        const deleteConfirmation = (item) => {
            const deletedItemName = _.get(item, "name", "Unknown");
            const deleteMessage = `Are you sure you want to delete "${deletedItemName}"?`;

            return this._uiUtils.showDeleteConfirmDialog({
                message: deleteMessage,
                confirmButtonName: "Confirm",
                cancelButtonName: "Cancel",
            });
        };

        return deleteConfirmation(item)
            .then(() => this.model.deleteField(uuid))
            .then(() => {
                this._slickDataVIew.deleteItem(uuid);
                this._slickTable.invalidate();
                this._slickTable.resizeCanvas();
                this._toggleNoDataPlaceholder(_.isEmpty(this._slickDataVIew.getItems()));
                // this._setActionButtonsAvailability();
            })
            .catch((error) => {
                if (error && !error.userRejected) {
                    if (_.isArray(error.errorMsg) && error.errorMsg.length > 0) {
                        const deletedItemName = _.get(item, "name", "");
                        const errorHead = deletedItemName
                            ? "Unable to delete the vault '" + deletedItemName + "'"
                            : "Unable to delete the vault";
                        this._modalUserFeedback.displayCustom(
                            new DeleteErrorVeilComponent(error.errorMsg, this._logger, errorHead)
                        );
                    } else {
                        const deletedItemName = _.get(item, "name", "");
                        const errorMsg = deletedItemName
                            ? "Unable to delete the vault '" + deletedItemName + "'"
                            : "Unable to delete the vault";
                        this._model._modalUserFeedback.displayError({
                            errorCode: "Delete Err",
                            errorMsg,
                            error,
                        });
                    }
                }
            });
    }

    _editItem(uuid) {
        const currentEty = this._model._vaults.filter((vault) => {
            return vault.id === uuid;
        });
        const type = uuid ? "edit" : "create";
        const component = new VaultEditComponent(
            type,
            currentEty[0],
            this._model._isReadOnly,
            this._model.activeOrgId,
            this._model._nibApiService,
            this._model._userSession,
            this._model._VaultsEntity,
            this._uiUtils
        );

        this._model._modalUserFeedback
            .displayCustom(component, {notDismissable: false})
            .then((data) => {
                if (type === "edit") {
                    return data.update();
                } else {
                    return data.create();
                }
            })
            .then(() => {
                return this._model.whenModelIsReady();
            })
            .then(() => {
                this._slickDataVIew.setItems(this._model._slickData);
                this._onSort(null, this._sortargs);
                this._toggleNoDataPlaceholder(_.isEmpty(this._model._slickData));
                this._slickTable.invalidate();
                this._slickTable.resizeCanvas();
            })
            .catch((error) => {
                if (error && !error.userRejected) {
                    this._model._modalUserFeedback.displayError({
                        errorCode: "Save Err",
                        errorMsg: "Unable to save the Vault.",
                        error,
                    });
                    this._logger.warn({error: error}, "Vault save error");
                }
            });
    }

    _setDirtyState() {
        this._model._isDirty = !_.isEqual(this._bannerData, this._model._updatedBannerData);
        // this._isValid = this._validateData();
    }

    _fitTableSize() {
        if (this._slickTable) {
            this._slickTable.resizeCanvas();
        }
    }

    _onDataUpdated() {
        this._unregisterListeners();
        this.render();
    }

    _onSort(e, args) {
        let col = args.sortCol;
        this._sortargs = args;

        let collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: "base",
        });

        this._slickDataVIew.sort(function (dataRow1, dataRow2) {
            let field = col.field;
            let value1 = dataRow1[field],
                value2 = dataRow2[field];
            return collator.compare(value1, value2);
        }, args.sortAsc);
        this._slickTable.invalidate();
        this._slickTable.render();
    }

    /* Control change events : End */
    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = VaultsRenderer;
